import { createFileRoute } from '@tanstack/react-router'

import { LABELS } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings/truck-classes'
)({
  meta: () => [{ title: LABELS.TRUCK_CLASS }]
})
